import { ComponentIds } from '@inter-ikea-core/core';
import { FpsController } from './FpsController';
export class FixedUpdateSystem {
    constructor(coreServices, ipexViewer, entities, onUpdate) {
        this.hasUpdates = false;
        this.frameRateController = null;
        this.coreServices = coreServices;
        this.ipexViewer = ipexViewer;
        this.entities = entities;
        this.onUpdate = onUpdate;
    }
    register() {
        const entityManager = this.coreServices.entityManager;
        this.ipexViewer.get_camera_updated_observable().add(() => {
            this.hasUpdates = true;
        });
        entityManager.subscribeAdd(ComponentIds.IN_SCENE_COMPONENT_ID, (entity) => {
            if (entity.hasComponent(ComponentIds.PRODUCT_COMPONENT_ID)) {
                this.hasUpdates = true;
            }
        });
        entityManager.subscribeUpdate(ComponentIds.LOCAL_TRANSFORM_COMPONENT_ID, (entity) => {
            if (entity.hasComponent(ComponentIds.IN_SCENE_COMPONENT_ID) &&
                (entity.hasComponent(ComponentIds.PRODUCT_COMPONENT_ID) ||
                    entity.hasComponent(ComponentIds.AUTOMATIC_ENTITY_GROUP_COMPONENT_ID))) {
                this.hasUpdates = true;
            }
        });
        this.frameRateController = new FpsController(60, () => {
            if (this.hasUpdates) {
                this.onUpdate(this.entities.getAllWithPosition());
                this.hasUpdates = false;
            }
        });
        this.frameRateController.start();
    }
}
//# sourceMappingURL=FixedUpdateSystem.js.map